<template>
  <a-modal
    title="编辑检验、检查表"
    :width="900"
    :visible="visible"
    :confirmLoading="confirmLoading"
    @ok="handleSubmit"
    @cancel="handleCancel"
  >
    <a-spin :spinning="confirmLoading">
      <a-form :form="form">
        <a-form-item v-show="false"><a-input v-decorator="['id']" /></a-form-item>
        <a-form-item
          label="处方id"
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
          has-feedback
        >
          <a-input placeholder="请输入处方id" v-decorator="['docitemId', {rules: [{required: true, message: '请输入处方id！'}]}]" />
        </a-form-item>
        <a-form-item
          label="挂号id"
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
          has-feedback
        >
          <a-input placeholder="请输入挂号id" v-decorator="['reId', {rules: [{required: true, message: '请输入挂号id！'}]}]" />
        </a-form-item>
        <a-form-item
          label="患者id"
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
          has-feedback
        >
          <a-input placeholder="请输入患者id" v-decorator="['paId', {rules: [{required: true, message: '请输入患者id！'}]}]" />
        </a-form-item>
        <a-form-item
          label="患者姓名"
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
          has-feedback
        >
          <a-input placeholder="请输入患者姓名" v-decorator="['paName', {rules: [{required: true, message: '请输入患者姓名！'}]}]" />
        </a-form-item>
        <a-form-item
          label="性别"
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
          has-feedback
        >
          <a-input placeholder="请输入性别" v-decorator="['sex', {rules: [{required: true, message: '请输入性别！'}]}]" />
        </a-form-item>
        <a-form-item
          label="身份证号"
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
          has-feedback
        >
          <a-input placeholder="请输入身份证号" v-decorator="['idCard', {rules: [{required: true, message: '请输入身份证号！'}]}]" />
        </a-form-item>
        <a-form-item
          label="项目名称"
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
          has-feedback
        >
          <a-input placeholder="请输入项目名称" v-decorator="['itemName', {rules: [{required: true, message: '请输入项目名称！'}]}]" />
        </a-form-item>
        <a-form-item
          label="类型"
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
          has-feedback
        >
          <a-input placeholder="请输入类型" v-decorator="['itemType', {rules: [{required: true, message: '请输入类型！'}]}]" />
        </a-form-item>
        <a-form-item
          label="日期"
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
          has-feedback
        >
          <a-input placeholder="请输入日期" v-decorator="['sheetPsdate', {rules: [{required: true, message: '请输入日期！'}]}]" />
        </a-form-item>
        <a-form-item
          label="查询报告的id"
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
          has-feedback
        >
          <a-input placeholder="请输入查询报告的id" v-decorator="['applyId', {rules: [{required: true, message: '请输入查询报告的id！'}]}]" />
        </a-form-item>
        <a-form-item
          label="金额"
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
          has-feedback
        >
          <a-input placeholder="请输入金额" v-decorator="['itemAmount', {rules: [{required: true, message: '请输入金额！'}]}]" />
        </a-form-item>
      </a-form>
    </a-spin>
  </a-modal>
</template>

<script>
  import { baSheetEdit } from '@/api/modular/interhospital/baSheet/baSheetManage'
  export default {
    data () {
      return {
        labelCol: {
          xs: { span: 24 },
          sm: { span: 5 }
        },
        wrapperCol: {
          xs: { span: 24 },
          sm: { span: 15 }
        },
        visible: false,
        confirmLoading: false,
        form: this.$form.createForm(this)
      }
    },
    methods: {
      // 初始化方法
      edit (record) {
        this.visible = true
        setTimeout(() => {
          this.form.setFieldsValue(
            {
              id: record.id,
              docitemId: record.docitemId,
              reId: record.reId,
              paId: record.paId,
              paName: record.paName,
              sex: record.sex,
              idCard: record.idCard,
              itemName: record.itemName,
              itemType: record.itemType,
              sheetPsdate: record.sheetPsdate,
              applyId: record.applyId,
              itemAmount: record.itemAmount
            }
          )
        }, 100)
      },
      handleSubmit () {
        const { form: { validateFields } } = this
        this.confirmLoading = true
        validateFields((errors, values) => {
          if (!errors) {
            for (const key in values) {
              if (typeof (values[key]) === 'object') {
                values[key] = JSON.stringify(values[key])
              }
            }
            baSheetEdit(values).then((res) => {
              if (res.success) {
                this.$message.success('编辑成功')
                this.confirmLoading = false
                this.$emit('ok', values)
                this.handleCancel()
              } else {
                this.$message.error('编辑失败')//  + res.message
              }
            }).finally((res) => {
              this.confirmLoading = false
            })
          } else {
            this.confirmLoading = false
          }
        })
      },
      handleCancel () {
        this.form.resetFields()
        this.visible = false
      }
    }
  }
</script>
